


















import { Component, Vue, Watch } from 'vue-property-decorator'
import { SnackbarMsgDTO } from '@/interfaces/SnackbarMsg.interface'

@Component
export default class SnackbarMsg extends Vue {
  private name: string = 'SnackbarMsg'

  private bInfo: SnackbarMsgDTO = {
    text: '',
    color: 'success',
    show: false,
    timeout: 2000
  }

  @Watch('snackbar.show')
  private watchSnackbar (v: boolean) {
    console.log('watchSnackbar :: ', v)
    if (!v) {
      this.$store.commit('setSnackbarMsg', this.bInfo)
    }
  }

  get snackbar () {
    return this.$store.state.appState.SnackbarMsg
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    console.log('snackbar :: ', this.snackbar)
  }
}
